import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';

import DistanceIcon from '-!svg-react-loader!./assets/img/distance.svg?name=DistanceIcon';
import DurationIcon from '-!svg-react-loader!./assets/img/duration.svg?name=DurationIcon';
import DepositIcon from '-!svg-react-loader!./assets/img/deposit.svg?name=DepositIcon';
import EditIcon from '-!svg-react-loader!./assets/img/edit.svg?name=EditIcon';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import OfferDetailsSelector from './selector';
import Item from './item';
import { SmallActionButton } from '../UIKit';
import messages from './messages';

import reducer from './reducer';
import saga from './saga';

import { displayOffers } from './actions';

import './styles.scss';

class OfferDetails extends React.Component {
  constructor(props) {
    super(props);
  }

  handleOnClick = e => {
    e.preventDefault();
    this.props.open();
  };

  render() {
    const { deposit, distance, duration, childOffers } = this.props;
    const hasChildOffers = childOffers.length > 1;
    return (
      <div id="OfferDetails">
        <div className="title">
          <FormattedMessage {...messages.title} />
          {hasChildOffers && (
            <SmallActionButton
              text={messages.button.defaultMessage}
              onClick={this.handleOnClick}
              icon={<EditIcon />}
            />
          )}
        </div>
        <div className="detail-item">
          <Item
            value={`${duration} mesi`}
            description={messages.duration.defaultMessage}
            iconComponent={<DurationIcon />}
            onClick={this.handleOnClick}
          />
          <Item
            value={parseInt(deposit).toLocaleString('it')}
            description={messages.deposit.defaultMessage}
            iconComponent={<DepositIcon />}
            onClick={this.handleOnClick}
          />
          <Item
            value={parseInt(distance).toLocaleString('it')}
            description={messages.distance.defaultMessage}
            iconComponent={<DistanceIcon />}
            onClick={this.handleOnClick}
          />
        </div>
        {hasChildOffers && <OfferDetailsSelector offers={childOffers} />}
      </div>
    );
  }
}
OfferDetails.defaultProps = {
  childOffers: [],
};

OfferDetails.propTypes = {
  deposit: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired,
  distance: PropTypes.number.isRequired,
  childOffers: PropTypes.array,
};

export function mapDispatchToProps(dispatch) {
  return {
    open: () => dispatch(displayOffers(true)),
  };
}

const mapStateToProps = createStructuredSelector({});

const withReducer = injectReducer({ key: 'offerDetailsSelector', reducer });
const withSaga = injectSaga({ key: 'offerDetailsSelector', saga });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(OfferDetails);
